import { ElectronAPI } from '../base/ElectronAPI';

import type {
  CanvasExportResult,
  CanvasRenderTarget,
} from '../../../../electron/shared';

export class CanvasExportAPI extends ElectronAPI {
  async render(
    html: string,
    width: number,
    target: CanvasRenderTarget
  ): Promise<CanvasExportResult> {
    if (!this.isElectronAvailable) {
      return { ok: false, error: 'Rendering a canvas needs the desktop app' };
    }
    return this.mainProcessApi.exportCanvas({ html, width, target });
  }
}
